import { render, staticRenderFns } from "./homeworkIndex.vue?vue&type=template&id=682f039c&scoped=true"
import script from "./homeworkIndex.vue?vue&type=script&lang=js"
export * from "./homeworkIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682f039c",
  null
  
)

export default component.exports